// CRM-owned addresses are hidden in the roster editor. Do not validate or
// resubmit them when saving website settings; an empty list leaves them intact.
export const getAgentAddressesForSave = (agent) => (agent.brivityUsersId ? [] : agent.addresses);
